/* src/app/private/components/view/orgnization-package/create-orgnization-package/create-orgnization-package.component.scss */
/*# sourceMappingURL=create-orgnization-package.component.css.map */
